import { types } from 'mobx-state-tree';
import Tree from './Tree';
import StructuredData from "./StructuredData";

export default types.model('MarketSettings', {
    LogoUrl: types.optional(types.string, ""), 
    CookieConsentText: types.optional(types.string, ""),
	TermsUrl: types.optional(types.string, ""),
    StoreLocatorUrl: types.optional(types.string, ""),
    MarketUrl: types.optional(types.string, ""),
    ProductCardUSP: types.optional(types.string, ""),
    MarketNavigationTree: types.optional(Tree, {}),
    StructuredData: types.maybeNull(StructuredData),
    HideWebshop: types.optional(types.boolean, false)
}).views(self => ({
    
})).actions(self => ({
	
}));
